<template>
    <div id="BulletinAddEdit">

        <b-modal id="modal-sm" size="md" title="Manage Bulletins" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
            <div slot="default">
                <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
                <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
            </div>
            <div slot="modal-footer" class="w-100">
                <p class="float-left" variant="primary"></p>
                <b-button variant="primary"  size="md"  class="float-right BtnClose"  @click="bulletinExit"> Close </b-button>
            </div>
        </b-modal>

    <b-modal id="pdfModel" size="md"  title="View PDF"  v-model="showPDF"  no-close-on-esc no-close-on-backdrop hide-header-close
        ok-variant cancel-variant
        :header-bg-variant=PopUpVar.headerBgVariant
        :header-text-variant=PopUpVar.headerTextVariant
        :body-bg-variant=PopUpVar.bodyBgVariant
        :body-text-variant=PopUpVar.bodyTextVariant
        :footer-bg-variant=PopUpVar.footerBgVariant
        :footer-text-variant=PopUpVar.footerTextVariant> 
        <BulletinViewPDF v-if="showPDF==true" :Doc="doc64String" :Size="size" ></BulletinViewPDF>
        <template slot="modal-header"> 
            <div>
            <small class="modal-title w-100 text-left">View PDF</small>
            </div> 
            <div v-show="Button=='Edit'"><small class="modal-title w-100 text-right">Bullet Name: {{bulletinname}}</small></div>
        </template> 
        <div slot="modal-footer" class="w-100"> 
        </div>
    </b-modal>

        <div class="form-group row  my-1">
            <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Service Type</label>
            <div class="col-sm-4">
                <select  id="service" :disabled="EditMode=='Edit'" v-model="servicetype"   class="form-control form-control-sm">
                    <option v-for="option in ServiceTypes" v-bind:value="{id: option.id, text: option.text, type:option.type}" :key="option.id">
                        {{ option.text }}
                    </option>
                </select>
                           </div>

        </div>
        <div class="form-group row my-1">
            <label for="BulletinName" class="col-sm-4 label-small my-0">Bulletin Name:</label>
            <div class="col-sm-4 my-0">
                <input id="BulletinName" type="text" maxlength="50"  placeholder="Bulletin Name" v-model="bulletinname" class="mb-0 form-control form-control-xs">
            </div>
            <div  class="col-sm-4" v-show="$v.bulletinname.$error">
                <div  class="row"  >
                     <small class="sml-red" v-if="!$v.bulletinname.required">Bulletin name is required</small>
                </div>
            </div>
        </div>
        <div class="form-group row my-1">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Effective Date:</label>
            <div class="col-sm-4 my-0">
                <datepicker  :disabled="mode=='Edit'" typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="effectivedate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker>
            </div>
            <div  class="col-sm-4" v-show="$v.effectivedate.$error">
                <div class="row">
                    <small class="sml-red" v-if="!$v.effectivedate.required">Effective date is required</small>
                </div>
            </div>
        </div>

        <div class="form-group row my-1">
            <label for="expiryDate" class="col-sm-4 label-small my-0">Expiry Date:</label>
            <div class="col-sm-4 my-0">
                <datepicker  :disabled="mode=='Edit'" typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="expirydate" :format="dateFormat" id="expiryDate" :bootstrap-styling="true" :input-class="datapickClass" name="expiryDatepicker"></datepicker>
            </div>
            <div  class="col-sm-4" v-show="$v.expirydate.$error">
                <div class="row">
                    <small class="sml-red" v-if="!$v.expirydate.required">Expiry date is required</small>
                    <small class="sml-red" v-if="!$v.expirydate.minValue1 && $v.expirydate.required">Expiry date must not be less than the effective date</small>
                </div>
            </div>
        </div>

        <div class="form-group row my-1">
            <label for="postDate" class="col-sm-4 label-small my-0">Post Date:</label>
            <div class="col-sm-4 my-0">
                <datepicker  :disabled="mode=='Edit'" typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="postdate" :format="dateFormat" id="postDate" :bootstrap-styling="true" :input-class="datapickClass" name="postDatepicker"></datepicker>
            </div>
            <div  class="col-sm-4" v-show="$v.postdate.$error">
                <div class="row">
                    <small class="sml-red" v-if="!$v.postdate.required">Post date is required</small>
                    <small class="sml-red" v-if="!$v.postdate.minValue1 && $v.postdate.required">Post date must not be less than the effective date</small>
                </div>
            </div>
        </div>
        <div class="form-group row my-1">
             <label for="postDate" class="col-sm-4 label-small my-0">PDF Document:</label>
            <div class="col-sm-4 my-0">
         <vue-upload-multiple-image
          :maxImage="1"
          :accept="ImageType"
          :showPrimary="false"
          :popupText="popupText"
          :primaryText="primaryText"
          :dragText="dragText"
          :browseText="browseText"
          :showEdit="false"
          :showAdd="false"
          :multiple="false"
          @upload-success="uploadImageSuccess"
          @before-remove="beforeRemove"
          @edit-image="editImage"
          :data-images="images"
          idUpload="myIdUpload"
          editUpload="myIdEdit"
          ref="img"
        ></vue-upload-multiple-image>
        {{popupText}}        
         
         
            </div>
            <div  class="col-sm-4" v-show="$v.docName.$error">
                <div class="row">
                    <small class="sml-red" v-if="!$v.docName.required">PDF is required</small>
                </div>
            </div> 
        </div> 
        <div v-if="EditMode=='Edit'" class="form-group row my-1">
            <label for="postDate" class="col-sm-4 label-small my-0">PDF Name:</label>
                <div class="col-sm-4 my-0 pointer">
                <a v-on:click="getPDF"><u>{{this.docName}}</u></a>
                <div>
        </div> 
        </div> 
        </div>
        <div> 
        </div>
        <hr>
        <div class="row" >
            <div class="col-sm-6" >
                <button :disabled="!canSave" v-on:click="SavePopup" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
            </div>
            <div class="col-sm-6">
                <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from 'vue';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'
import { required,minLength} from 'vuelidate/lib/validators' 
import { constants } from 'crypto';
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue';
import VueUploadMultipleImage from "vue-upload-multiple-image";
import vueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
    props:{
        UserData:'',
        Button:''
    },
    data: function(){
        return {
     ImageType: "application/pdf",
      popupTitle: "", 
      popupText: "",
      primaryText: "",
      PaidByThirdPArty: false,
      dragText: "Upload New Bulletin File",
      browseText: "Click Here",
      images: [],
      fileList: "",
            btnName:'Add Bulletin',
            saveIcon:'fas fa-plus',
            showEdit:true,
            EditMode:'',
            ServiceTypes:[],
            servicetype:'6',
            Msg:'',
            showModal:false,
            succeeded:true,
            bulletinname:'',
            effectivedate:'',
            expirydate:'',
            postdate:'',
            myVueDropzone:'',
            pdf:undefined,
            mode:'',
            canSave:true,
            dateFormat:'',
            datapickClass:"form-control form-control-xs my-0",
            docType:'',
            docName:'',
            doc64String:undefined,
            showPDF:false,
            size:'40%',
            id:'',
            PopUpVar:PopUpVariant,
            dropzoneOptions: {
                url: 'https://httpbin.org/post',
               // thumbnailWidth: 150,
                //maxFilesize: 0.5,
                maxFiles:1,
                maxFilesize:20,
                headers: { "My-Awesome-Header": "header value" },
                acceptedFiles: "application/pdf",
                resizeHeight: "10px"
            }
        }
    },
    components:{
        Modal:Modal,
        Card,
        CardBody,
        TileNote,
        Datepicker,
           vueDropzone,
             VueUploadMultipleImage,
    },
    created:function(){
        this.EditMode = this.Button;
        this.dateFormat = this.$store.getters.GetDateFormat;
        if(this.EditMode  == 'Edit')
        {
            this.btnName = 'Edit Bulletin';
            this.saveIcon = 'far fa-edit'; 
            this.canSave = true;
        }

        this.effectivedate = moment(this.UserData.effectivedate==undefined?new Date():this.UserData.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.expirydate = moment(this.UserData.expirydate==undefined?'9999/12/31':this.UserData.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.postdate =  moment(this.UserData.postdate==undefined?new Date():this.UserData.postdate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.bulletinname = this.UserData.bulletinname==undefined?'':this.UserData.bulletinname;
        this.doc64String = this.UserData.pdf==undefined?'':this.UserData.pdf;

        this.id = this.UserData.id==undefined?0:this.UserData.id;
        
        this.docName = this.UserData.pdfname==undefined?'':this.UserData.pdfname;
        var vm = this;

        axios.get('SaskHealthApi/Codes/GetServicesComboWithoutDPEBB?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
            .then(function (response) {
                vm.ServiceTypes=response.data.items;
                 vm.ServiceTypes.push({id:'6', text:'All',type:'All'})
                vm.servicetype = vm.ServiceTypes.find(x=>x.text === vm.UserData.name);

               if(vm.servicetype == undefined)
                    vm.servicetype =  vm.ServiceTypes.find(x=>x.text === "All");
             })
            .catch(function (er) {

                //console.log(er)

            })



    },
    methods:{
    uploadImageSuccess(formData, index, filelist) {
      this.fileList = filelist;
      //////console.log('data = ', formData)
      //////console.log('index = ', index)
      //console.log('filelist = ', filelist)
      if (filelist[0].Filetype == "application/pdf")  
        {
        this.popupText = filelist[0].name;
        //console.log("is csv OK");
          this.pdfname= filelist[0].name;
          this.docName =  this.pdfname;
          this.pdf= filelist[0].path.split(",")[1];
          this.doc64String = filelist[0].path.split(",")[1];
          this.doctype= filelist[0].Filetype;
          //console.log("pdf = " +this.doctype);
      } else {
        this.showMsg(
          "File type not allowed. Please upload the Bulletin again.",
          "",
          "Bulletin Upload Error"
        );
        this.images = [];
      }
      // _.forEach(filelist, function(value, key) {
      //   ////console.log(value.path.split(',')[1]);
      // });
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   ////console.log(response)
      // })
      //////console.log("file List", this.fileList);
    },
    showMsgBox(msg, data, MethodNo, done) {
      var vm = this;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Please Confirm",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          cancelVariant: "default",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          //////console.log(value)
          if (value) {
            if (MethodNo == 2) {
              vm.popupText = "";
              done();
              //vm.DelConfirm = this.boxTwo;
            }
            if (MethodNo == 1);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    beforeRemove(index, done, fileList) {
      this.showMsgBox(
        "Are you sure you want to delete the file ? ",
        "",
        2,
        done
      );
    },
    editImage(formData, index, fileList) {
      //this.popupText = fileList[0].name;
      //this.uploaddoc();
      //////console.log('edit data', formData, index, fileList)
    },
    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
        ClosePopup: function() {
            this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow')
            //this.$v.$reset();
        },
        SavePopup: function(){
                 //console.log(" BASE 64 => " + this.doc64String)
                this.$v.$touch(); 
                if (!this.$v.$invalid){
                //    //console.log*this.
                   // //console.log(this.pdf.dataURL);
                this.canSave = false;
                    var vm = this;
                    var bodyFormData = new FormData();
                    var parms = {
                        'id':vm.id,
                        'bulletinname':vm.bulletinname,
                        'pdfname':vm.docName,
                        'pdf':vm.doc64String,
                        'doctype':vm.doctype,
                        'serviceid':vm.servicetype.id,
                        'effectivedate':vm.effectivedate,
                        'expirydate':vm.expirydate,
                        'postdate':vm.postdate};
                   
                    bodyFormData.append('BulletinData',JSON.stringify(parms));
                    var url = "/SaskHealthApi/Security/PostManageBulletins/"
                    axios({
                        method: 'post',
                        url: url,
                        //headers: {'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                        data: bodyFormData
                        }).then(function (response) {
                            //console.log("yes");
                            //console.log(response);
                            if(response.status ==200)
                            {
                                vm.succeeded = true;
                                vm.Msg="Bulletin Successfully Saved For " + vm.bulletinname + ".";
                                //vm.Msg="<div class='alert alert-warning' role='alert'>"+'Permission Not Saved Successfully Saved For ' +  vm.selectRole.text +"</div>";
                                vm.showModal=true;
                               
                            }
                            else  if(response.status == 400){
                                vm.succeeded = false;
                                vm.Msg="Warning: Bulletin Not Successfully Saved For "+ vm.bulletinname +  ".";
                                vm.showModal=true;
                            }
                            else  if(response.status == 500){
                                vm.succeeded = false;
                                vm.Msg="Warning: System Error ! Bulletin Not Successfully Saved For "+ vm.bulletinname +  ".";
                                vm.showModal=true;
                            }
                    })
                    .catch(function (er) {
                    //console.log(er)
                     vm.canSave = true;
                     vm.succeeded = false;
                     vm.Msg="Warning: Bulletin Not Successfully Saved For "+ vm.bulletinname +  ".";
                     vm.showModal=true;
                    }).then(function () {

                    });
                }
               },
         bulletinExit: function(){
            this.showModal=false;
            if(this.succeeded){
            this.$emit('bulletinUpdated');
            }

        },
        handleFileAdding(file){
            this.canSave= false;
            if(!(this.pdf==undefined)){
                this.$refs.myVueDropzone.removeFile(this.pdf)
                this.doc64String = '';
            }
                

        },
        enableSave(file, response){ 
            // this.$refs.myVueDropzone.removeAllFiles(this.pdf)
            if(file.accepted){
                // if(!(this.pdf==undefined))
                    // his.$refs.myVueDropzone.removeFile(this.pdf)

                 var fileReader = new FileReader();
	                var base64;
	                fileReader.onload = (fileLoadedEvent) => {
	                    base64 = fileLoadedEvent.target.result;
	                    //this.pdf.dataURL= base64; this.pdf.dataURL= base64;
	                };
                    fileReader.readAsDataURL(file);
                    if(fileReader.result){
                            this.doc64String =  (base64.split(";")[1].split(",")[1]);
	                		// USE the DATAURL
	                		//clearInterval(checkIfReady);
                        }
                        
	                // Checks every second for the dataURL.
	                var checkIfReady = setInterval(()=>{
	                	// If there is it logs it.
	                	if(fileReader.result){
                            this.doc64String =  (base64.split(";")[1].split(",")[1]);
                            // //console.log( this.doc64String );
                            // USE the DATAURL
                         
	                		clearInterval(checkIfReady);
	                	}
	                	// Stops checking after 10 seconds.
	                	setTimeout(()=>{
	                		clearInterval(checkIfReady);
	                	}, 10000)
                    },1000);
    
                this.canSave = true;
                this.pdf = file;
                //console.log("This PDF = " + this.pdf)
                this.docType = file.type;
                this.docName = file.name;
                this.canSave = true;
                }
                else{
                    this.$refs.myVueDropzone.removeAllFiles();
                }   

            },
           getPDF:function(){
                const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = []; 
                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                } 
                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
                }   
                    var vm = this;
                    var url = 'SaskHealthApi/Security/GetPDF?_='
                    var params = new URLSearchParams();
                    params.append("id", vm.id);
                    axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
                    .then(function (response) {
                        const contentType = 'application/pdf';

                        const blob = b64toBlob(response.data.pdf, contentType);
                        // const blobUrl = URL.createObjectURL(blob);

                        // const downloadLink = document.createElement("a");
                        const fileName = vm.docName;

                        // downloadLink.href =  blobUrl;
                        // downloadLink.download = fileName;
                        // downloadLink.click();

                        // var url = URL.createObjectURL(blob);
                        // var myWindow = window.open(blobUrl, "_blank");
                        // myWindow.open(url,"_blank");
                        
                    var win = open('', '_blank');
                    
                    win.document.write(
                    '<html><body><center>' +
                    '<a title="Download PDF" style="font-family: \'Verdana\';color: #333;text-decoration: none;font-weight: 600;" download="' + vm.docName + '" href="data:application/pdf;base64,' + response.data.pdf + '">Download File</a>' +
                    '</center><br>' +
                    '<object width=100% height=100% type="application/pdf" data="data:application/pdf;base64,' + response.data.pdf  + '">' +
                    '<embed type="application/pdf" src="data:application/pdf;base64,' + response.data.pdf  + '" id="embed_pdf"></embed>' +
                    '</object></body></html>');
                    })
                    .catch(function (er) {
                    //console.log(er)
                    });
        
                }
     },
    validations(){
       return {

            docName:{
                required
            },
            bulletinname:{
                required
            },
            effectivedate:{
            required
            },
            expirydate:{
                required,
                minValue1: value => moment(this.expirydate).startOf('day').toISOString() >= (moment(this.effectivedate).startOf('day')).toISOString()
            },
            postdate:{
                required,
                 minValue1: value => moment(this.postdate).startOf('day').toISOString() >= (moment(this.effectivedate).startOf('day')).toISOString()
            }
       }
    }

}   

</script>

<style>

.dropzone .dz-preview .dz-image {
  border-radius: 0px;
  /* overflow: hidden; */
  width:90px;
  height: 60px;
  position: relative;
  display: block;
  padding-right: 50px;
  z-index: 10;
}
</style>
